import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthService, GoogleUser} from "../../services/auth.service";
import {Observable} from "rxjs";


@Component({
    selector: 'app-google-auth-button',
    templateUrl: './google-auth-button.component.html',
    styleUrls: ['./google-auth-button.component.scss'],
    imports: []
})
export class GoogleAuthButtonComponent implements OnInit {

  user$: Observable<GoogleUser | null>;
  @Output() loginSuccess = new EventEmitter<void>();

  constructor(public auth: AuthService) {
    this.user$ = this.auth.user$;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Initialize the Google button in the element with id 'google-signin-button'

  }

  signOut() {
    this.auth.signOut();
  }

  signInWithGoogle() {
    this.auth.signInWithGoogle().then(() => this.loginSuccess.emit());
  }
}
